/** Stub — sale finalization stays on legacy Express until Lumora finance APIs land. */
export default function SellVehicleModal(_props: {
  car: unknown;
  onClose: () => void;
  onSaleSuccess: () => void;
  canFinalizeSale: boolean;
}) {
  return null;
}
